import { PUBLIC_PATHS } from "@/utils/constants";
import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useEffect } from "react";



export const useAuthenticatedUser = () => {
  const router = useRouter();
  const { data: session, status, update } = useSession();

  useEffect(() => {
    if (router.pathname === "/" || router.pathname === "/en") {
      return;
    }
    if (
      status === "unauthenticated" &&
      ![...PUBLIC_PATHS, ...PUBLIC_PATHS.map((p) => "/en" + p)].some((path) =>
        router.pathname.includes(path)
      )
    ) {
      signIn("auth0", {
        callbackUrl: `${window.location.origin}/router`,
      });
    }
  }, [status, router]);

  return {
    userProfile: session?.userProfile,
    user: session?.user,
    update,
    status,
  };
};
